import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './components/Buttons.css';
import './index.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <div className='App-Container'>
      <HelmetProvider>
        <Router>
          <App />
        </Router>
      </HelmetProvider>
    </div>
  </React.StrictMode>
);